import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import {returnEmptyIfNull} from 'utils/string-utils';
import actionTypes from '../constants/user-detail-action-types';

import type {List, Map} from 'immutable';

export type UserDetailStore = {
    activity: List<unknown>;
    sessions: List<unknown>;
    user: Map<unknown, unknown>;
};

const initialState = () => {
    return {
        activity: Immutable.List(),
        sessions: Immutable.List(),
        user: Immutable.Map(),
    };
};

const actionsMap = {
    [actionTypes.GET_USER_SUCCESS]: (state, action) => {
        return {
            user: returnEmptyIfNull(action.data, ['middleName', 'number']),
        };
    },

    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<UserDetailStore>(initialState(), actionsMap);
